import React from "react";
import { icon } from "../functions/icons";
import { HorizontalLayout } from "../components/layout";

export function Chip({ label, variant = "default", size = "medium", onClick, onClose, disabled = false, iconStart, iconEnd, className = "", style = {}, input,id_name }) {
  const isClickable = !!onClick && !disabled;
  const classes = ["chip", `chip--${variant}`, `chip--${size}`, disabled ? "chip--disabled" : "", isClickable ? "chip--clickable chip--hoverable" : "", className].join(" ");
  const handleClose = e => { e.stopPropagation(); if (!disabled && onClose) onClose(e); };
  const handleKeyDown = e => { if (!disabled && onClick && (e.key === "Enter" || e.key === " ")) onClick(); };
  return (
    <div
      className={classes}
      style={style}
      onClick={() => !disabled && onClick && onClick()}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      {iconStart && <span className="chip__icon chip__icon--start">{icon(iconStart)}</span>}
      <span className="chip__label">{label}</span>
      {onClose && <button type="button" className="chip__close" onClick={handleClose} aria-label="Remove chip" tabIndex={-1}>×</button>}
      {iconEnd && !onClose && <span className="chip__icon chip__icon--end">{icon(iconEnd)}</span>}
      {input && input}
    </div>
  );
}
export const ChipFilter = ({ options, selected, onSelect, size="large", wrap=false, id_name="id", all_selected=false }) => {
    return (
        <HorizontalLayout className="chip-filtere-scroll" style={{ gap:"1rem",flexWrap: wrap?"wrap":"" }}>
            {options.map((opt) => (
                <Chip      
                    size={size}
                    key={opt[id_name]}
                    label={opt.label}
                    className={selected == opt[id_name] || all_selected ? "selected" : ""}
                    onClick={() => onSelect(opt[id_name])} 
                />
            ))}
        </HorizontalLayout>
    )
}